import script from "./NovelReader.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelReader.vue?vue&type=script&setup=true&lang=js"

import "./NovelReader.vue?vue&type=style&index=0&id=c774d41a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c774d41a"]])

export default __exports__